angular.module("files_types_whitelist")

    .controller("FilesTypesWhitelistListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate','$state',
        function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate, $state) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("EVENTS_TYPES_WRITE");

        $rootScope.title = $filter('translate')('files_types_whitelist.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('files_types_whitelist.title') }
        ];

        $scope.search = {
            entity_type: ""
        };

        $scope.gridOptions = {
            pdfTitle: $filter('translate')('files_types_whitelist.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            enableSorting: true,             
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
              { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                { name: 'FK_files_types_whitelist_files_types.description', displayName: $filter('translate')('files_types.description'), enableFiltering: true, enableHiding: false },
                { name: 'maxsize', displayName: $filter('translate')('files_types.maxsize'), enableFiltering: true, enableHiding: false },
                { name: 'entity_type', displayName: $filter('translate')('files_types.entity'), enableFiltering: true, enableHiding: false },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('general.edit'), action: 'ui-sref="files_types_whitelist.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('general.delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.FK_files_types_whitelist_files_types.description);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {
                options.entity_type = $scope.search.entity;
                return Restangular.all('FilesTypesWhitelist').getList(options);
            }
        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("files_types_whitelist.edit", { id: rowEntity.id });
        }


        $scope.searchEntity = function () {
            if (angular.isDefined($scope.gridOptions.loadData)) {
                $scope.gridOptions.loadData(false);
            }
        }

        $scope.deleteDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('general.delete'),
                message: $filter('translate')('general.delete_message') + " " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('FilesTypesWhitelist', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('general.delete_success'));
                        $scope.gridOptions.gridApi.core.raise.itemDeleted($scope);
                        
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };
        
    }])

;